<template>
  <div id="app">
    <keep-alive :include="include">
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
import {wxShareInit} from "@/lib/utils/wxSdk";
export default {
  name: 'App',
  data () {
    return {
      include: []
    }
  },
  mounted () {
    wxShareInit()
  },
  watch: {
    $route (to, from) {
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name)
      }

      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        const index = this.include.indexOf(from.name)
        index !== -1 && this.include.splice(index, 1)
      }

      // ciss跳转新服务
      if (to.path === '/ciss') {
        window.location.href = this.$cissSite
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
